/**
 * TabBar — fixed bottom navigation.
 * tabs: [{ id, name, icon (lucide component), component }]
 */
import React from 'react';

export default function TabBar({ tabs, activeTab, setActiveTab }) {
  return (
    <nav className="tab-bar">
      {tabs.map((tab) => {
        const Icon = tab.icon;
        const isActive = tab.id === activeTab;
        return (
          <button
            key={tab.id}
            className={`tab-item ${isActive ? 'tab-item-active' : ''}`}
            onClick={() => setActiveTab(tab.id)}
            aria-current={isActive ? 'page' : undefined}
          >
            {Icon && <Icon size={22} />}
            <span className="tab-label">{tab.name}</span>
          </button>
        );
      })}
    </nav>
  );
}
